<template>
  <Wrapper
    id="section-hover-frame"
    :position="slideSectionHover.position" 
    v-show="!preview && renderTools && slideSectionHover.id && slideSectionHover.id != slideSectionActive.id && 
    !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode)
    "
    :class="{'top': !oversection || !isFirstIndex, 'bottom': oversection && isFirstIndex}"
    @click="click"
    style="cursor: pointer;"
  >
    <!-- <pre>{{ slideSectionHover }}</pre> -->

    <FloatframeHover class="text-center lbl-name" :lv="dt.lv">
     Slide
    </FloatframeHover>

    <template v-if="detectDevice == 'desktop'">
      <AddSection class="add-section top">
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('up', slideSectionHover.id)">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                  Add Section
              </span>
            </div>
          </div>
        </div>  
      </AddSection>
      <AddSection
        v-if="!isSectionPage"
        class="add-section bottom"
      >
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('down', slideSectionHover.id)">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                  Add Section
              </span>
            </div>
          </div>
        </div>
      </AddSection>
    </template>

    <!-- <FloatframeHeaderHover>{{ slideSectionHover.name }} </FloatframeHeaderHover> -->
    <!-- <pre>{{ slideSectionHover }}</pre> -->
    <!-- <FloatframeHover v-else>{{ slideSectionHover.name }} </FloatframeHover> -->
  </Wrapper>
</template>
<script>
import {
  //   FloatframeHeaderHover,
  //   SectionName,
  AddSection,
  FloatframeHover,
  Wrapper,
} from "@components/tool/FloatFrameHover.styled.js";
import { mapGetters } from "vuex";
export default {
  components: {
    // SectionName,
    // FloatframeHeaderHover,
    AddSection,
    FloatframeHover,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  computed: {
    ...mapGetters({
      components: "designIframe/metadata/components",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      slideSectionHover: "designIframe/frame/slideSectionHover",
      slideSectionActive: "designIframe/frame/slideSectionActive",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      detectDevice: "detectDevice",
      siteComponents: "designIframe/metadata/siteComponents",
      sitePageID: "designIframe/metadata/sitePageID",
      limit: "designIframe/page/limit",
    }),
    sections() {
      return this.CONTENT_CONTAINER.componentsID;
    },
    dt() {
      return {
        name: "",
        id: undefined,
        lv: 0,
        ...this.slideSectionHover,
      };
    },
    isSectionPage() {
      return this.slideSectionHover.id === "SECTION_PAGE";
    },
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    indexSection() {
      return this.CONTENT_CONTAINER.componentsID.indexOf(this.slideSectionHover.id);
    },
    isFirstIndex() {
      return this.indexSection == 0;
    },
    sectionComponent() {
      return this.slideSectionHover.id && this.components[this.slideSectionHover.id]
    },
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      return mainPageID;
    },
    oversection() {
      return (
        this.sitePageID == this.getMainPage && this.HEADER.style.isEnableOverSection
      );
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
  },
  methods: {
    addSection(direction, section_id) {
      const sectionCountInPage = this.sections.length;
      if(!this.limit.section || sectionCountInPage < this.limit.section) {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: section_id,
            direction,
          },
          path: "/component/addComponent/section",
        });
        this.$store.dispatch("design/setMode", {
          mode: "add_section",
        });
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
      }

      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: section_id,
        name: section_id,
      });
      
      this.$store.dispatch("designIframe/frame/setCellActive", {});
      this.$store.dispatch("designIframe/frame/setCellHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
    },
    click(e) {
      e.stopPropagation();
      var compID = this.slideSectionHover.id;
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
        component_id: compID,
        index: this.slideSectionHover.index
      })
      this.$store.dispatch("designIframe/frame/setSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
      this.$store.dispatch("designIframe/frame/setCellActive", {});
      this.$store.dispatch("designIframe/frame/setCellHover", {});
      this.$store.dispatch("designIframe/frame/setWidgetActive", {});
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

      this.$store.dispatch("designIframe/component/elActive", {
        elementID: ["component", compID, this.sectionComponent.componentsID[this.slideSectionHover.index]],
      });
    },
  },
  watch: {
    slideSectionHover: {
      deep: true,
      handler() {
        const element = document.getElementById("section-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
};
</script>
